<template>
  <div class="v-button-wrapper">
    <v-tooltip
      top
      :disabled="!tooltipMessage"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :id="generateId"
          data-testid="v-btn"
          :type="type"
          :color="color"
          :loading="loading"
          class="naj-button"
          :class="{
            light,
            square,
            small: size === 'small',
            'inputs-alignment': inputsAlignment,
          }"
          v-bind="{ [size]: !!size, text, rounded, outlined, disabled: disabled || loading }"
          :to="to"
          :href="href"
          :target="target"
          @click="clickHandler"
          v-on="on"
        >
          <v-icon v-if="icon">
            {{ icon }}
          </v-icon>
          <slot />
        </v-btn>
      </template>
      <span v-html="tooltipMessage" />
    </v-tooltip>
  </div>
</template>

<script>
import { generateHtmlTagId } from '@/helpers/utils';

export default {
  name: 'NajButton',
  props: {
    type: {
      required: false,
      default: 'button',
    },
    color: {
      required: false,
      default: 'primary',
    },
    icon: { required: false },
    loading: {
      required: false,
      default: false,
    },
    light: { type: Boolean },
    square: { type: Boolean },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      required: false,
      default: '',
      validator(value) {
        // the value must be one of this array items
        return !value || ['large', 'small'].indexOf(value) !== -1;
      },
    },
    text: { required: false },
    outlined: { required: false },
    rounded: { required: false },
    inputsAlignment: {
      type: Boolean,
      required: false,
    },
    to: {
      type: [String, Object],
      required: false,
    },
    href: {
      type: String,
      required: false,
    },
    target: {
      type: String,
      required: false,
      default: '_self',
    },
    tooltipMessage: {
      type: String,
      required: false,
    },
  },
  computed: {
    generateId() {
      return generateHtmlTagId(this, 'btn');
    },
  },
  methods: {
    clickHandler(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
    .v-button-wrapper {
        display: inline-block;

        &::v-deep .naj-button {
            box-shadow: none;
            padding: 9px 15px !important;
            border-radius: 4px;
            min-height: 30px;
            min-width: 100px;
            letter-spacing: normal;
            border-width: 2px;
            margin: 0 5px;

            span {
                font-weight: 700;
                font-size: 17px;
            }

            &.primary {
                min-width: auto;
                // Important is wrong here, But i added to only overwrite vutify.
                background-color: var(--app-primary-color) !important;

                span {
                    color: #fff;
                }
            }

            &.v-btn--outlined.primary--text {
                border-color: var(--app-primary-color);

                span {
                    color: var(--app-primary-color);
                }

                .v-icon {
                    width: 20px;
                    height: 20px;
                    position: relative;
                    right: -15px;
                }

                &.small {
                    .v-icon {
                        width: 18px;
                        height: 18px;
                        position: relative;
                        right: -5px;
                        font-size: 15px;
                    }
                }
            }
            // Light case
            &.light {
                // Important is wrong here, But i added to only overwrite vutify.
                background-color: #01ac66 !important;
                box-shadow: 0 0 8px #9adcc1;
                min-width: 219px;

                span {
                    font-size: 14px;
                }
            }

            &.square {
                min-width: 104px;
                border-radius: 0px;
            }
            // Size
            &.small {
                min-height: 33px;
                font-weight: 500;
                padding-left: 15px;
                padding-right: 15px;

                span {
                    font-size: 14px;
                }

                .v-icon {
                    width: 30px;
                    height: 20px;
                    position: relative;
                    right: -5px;
                }
            }
        }
    }
.inputs-alignment {
  margin-top: 26px;
}
.theme--light.v-btn.primary.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #009587 !important;
}

::v-deep .v-btn--rounded {
  border-radius: 28px !important;
}
</style>
